import { ModelService } from './ModelService';
import { Log } from '../../model/Log';
import { ILogService } from '../ILogService';

export class LogService extends ModelService<Log> implements ILogService {
}